import { BaseState } from "../..";
import { TransactionMessage, TransactionMessageErrorDetails, TransactionMessageIssueSeverity } from "../../../app/data/transaction-monitor/models";

export interface TransactionMessagesState {
  requestStarted: boolean;
  fetchPortionStarted: boolean;
  requestCreator: string;
  requestSucceed: boolean;
  requestFailed: boolean;
  requestFailStatus: number;
  requestError: string;
  hasNextPage: boolean;
  nextCursor: string;
  messages: TransactionMessage[];
}

export interface TransactionMessageIssueState extends BaseState {
  id: string;
  severity: TransactionMessageIssueSeverity;
  errorDetails: TransactionMessageErrorDetails;
  createdAt: string;
  createdBy: string;
}

export interface TransactionMessageDumpState extends BaseState {
  id: string;
  messageData: string;
  messageDataFormat: string;
  createdAt: string;
  createdBy: string;
}

export interface TransactionMessageReprocessState extends BaseState {

}

export const initialTransactionMessagesState: TransactionMessagesState = {
  requestStarted: false,
  fetchPortionStarted: false,
  requestCreator: "",
  requestSucceed: false,
  requestFailed: false,
  requestFailStatus: 0,
  requestError: "",
  hasNextPage: true,
  nextCursor: "",
  messages: []
};

export const initialTransactionMessageIssueState: TransactionMessageIssueState = {
  loading: false,
  loadingFailed: false,
  loaded: false,
  id: "",
  severity: {
    id: "",
    name: "",
    allowNotification: false,
    createdAt: "",
    createdBy: ""
  },
  errorDetails: {
    id: "",
    errorText: "",
    errorFormat: "",
    createdAt: "",
    createdBy: ""
  },
  createdAt: "",
  createdBy: ""

}

export const initialTransactionMessageDumpState: TransactionMessageDumpState = {
  loading: false,
  loadingFailed: false,
  loaded: false,
  id: "",
  messageData: "",
  messageDataFormat: "",
  createdAt: "",
  createdBy: ""
}

export const initialTransactionMessageReprocessState: TransactionMessageReprocessState = {
  loading: false,
  loadingFailed: false,
  loaded: false
}